import { render, staticRenderFns } from "./BasicTicket.vue?vue&type=template&id=2b7e46bc&scoped=true&"
import script from "./BasicTicket.vue?vue&type=script&lang=js&"
export * from "./BasicTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e46bc",
  null
  
)

export default component.exports